export function setFirstName(state, name) {
  state.firstName = name;
}

export function setLastName(state, name) {
  state.lastName = name;
}

export function setEmail(state, value) {
  state.email = value;
}

export function setPin(state, pin) {
  state.pin = pin;
}

export function increasePinAllowedAttempts(state) {
  state.pinAttempts = state.pinAttempts + 1;
}

export function setCreateUserError(state, error) {
  state.createUserError = error;
}

export function setSignUpPinError(state, error) {
  state.signUpPinError = error;
}

export function setSignUpPinFailureReason(state, error) {
  state.signUpPinFailureReason = error;
}

export function setPinAttempts(state, { attempt, maxAttempt }) {
  state.pinAttempts = attempt;
  state.pinAllowedAttempts = maxAttempt;
}

export function setState(state, [field, value]) {
  state[field] = value;
}
